import { ComponentPropsWithRef, PropsWithChildren } from "react";
import { Icon } from "src/components";

export interface Props extends PropsWithChildren<ComponentPropsWithRef<"div">> {
  data: string | undefined;
  color: string;
  removable?: Function;
}

const Pill = (props: Props) => {
  const clearSelected = () => {
    if (props.removable) {
      props.removable();
    }
  };
  return (
    <div data-testid="pillcell" className="cell-pills-container">
      <div
        className={`pill ${props.color}Pill flex justify-between items-center`}
      >
        <span data-testid="pillcell-data">{props.data}</span>
        {props.removable && (
          <Icon
            name="times"
            className="h-4 w-4 cursor-pointer pl-2"
            onClick={clearSelected}
          />
        )}
      </div>
    </div>
  );
};

export default Pill;
